export function canAttemptSignalRStart(authExpired) {
  return !authExpired
}

export function shouldEnsureHubSubscribe({
  hubSubscribed,
  authExpired,
  connectionState,
  connectedState,
}) {
  return (
    !hubSubscribed &&
    !authExpired &&
    connectionState === connectedState
  )
}
